/**
 * AI trace-id minting. Every AI artifact (chat answer, brief card, copilot
 * reply, forecast, report edit) should carry a stable `ai_trace_id` so its
 * feedback and bug reports can be joined back to the agent trace in BigQuery.
 */

let counter = 0

export function newAiTraceId(prefix = 'ai'): string {
  const uuid = (() => {
    try {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
      }
    } catch {
      /* fall through to manual id */
    }
    counter += 1
    const rand = Math.random().toString(36).slice(2, 10)
    return `${Date.now().toString(36)}-${rand}-${counter.toString(36)}`
  })()
  return `${prefix}_${uuid}`
}
